import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';  // 모듈형 CSS 사용

// import calendarIcon from '../../assets/status/completed_icon.svg';  // 달력 아이콘 경로 확인
import calendarIcon from '../../assets/Button/Calendar.svg';  // 달력 아이콘 경로 확인
import profileIcon from '../../assets/mypage/mypage.svg';    // 프로필 아이콘 경로 확인

// Header 컴포넌트
const Header = ({ title, showCalendarIcon, showProfileIcon, goToToday }) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate('/mypage');
  };

  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.icons}>
        {showCalendarIcon && (
          <img
            src={calendarIcon}
            alt="달력 아이콘"
            className={styles.Calendaricon}
            onClick={goToToday}  // 아이콘 클릭 시 goToToday 함수 실행
          />
        )}
        {/* {showProfileIcon && (
          <img
            src={profileIcon}
            alt="프로필 아이콘"
            className={styles.icon}
            onClick={handleProfileClick}  // 아이콘 클릭 시 ./mypage로 이동
          />
        )} */}
      </div>
    </div>
  );
};

export default Header;
